import { backendServices, BusinessDocType, DeliveryMethod, FileType, PurchaseOrderFileFormat } from 'common';
import { SupplierSignUpData } from './SupplierSignUpSchema';

function vmToAccountAndContactStep(
    vm: backendServices.ViewModels.CompanyUserProfileViewModel
): SupplierSignUpData['accountAndContact'] {
    const primaryContact = vm.Company.Contacts[0];

    // Split the full name into first and last name
    const fullNameParts = (primaryContact?.Name ?? '').split(' ');
    const firstName = fullNameParts[0] || '';
    const lastName = fullNameParts.slice(1).join(' ') || '';

    return {
        loginEmail: vm.User.Email,
        password: '',
        passwordConfirmation: '',
        firstName,
        lastName,
        title: primaryContact?.Title ?? undefined,
        phone: primaryContact?.Phone ?? '',
    };
}

function vmToCustomerStep(vm: backendServices.ViewModels.CompanyUserProfileViewModel): SupplierSignUpData['customer'] {
    const invoiceCurrency = vm.Profiles.find((p) => p.Currency != null)?.Currency ?? 0;

    const salesProfile = vm.Profiles.find((p) => p.ProfileType === backendServices.ViewModels.ProfileType.Sales);

    const poDeliveryMethod = salesProfile?.ProfileDeliveryMethods.find(
        (method) => method.BusinessDocType === BusinessDocType.PurchaseOrder
    );
    const poDeliveryMethodType = poDeliveryMethod?.DeliveryMethod;
    const poDeliveryMethodFileType = poDeliveryMethod?.ProfileDeliveryFileTypes?.[0].FileType;
    // * cannot infer other fileTypes, because we default to FileType.XML if it's not PDF
    const poDeliveryMethodFileFormat = poDeliveryMethodFileType === FileType.PDF ? PurchaseOrderFileFormat.PDF : null;
    const poDeliveryEmail = poDeliveryMethod?.EmailAddress;

    const emailIsRequired = poDeliveryMethodType === DeliveryMethod.Email;

    const enablePODelivery =
        poDeliveryMethodType != null &&
        (!emailIsRequired || poDeliveryEmail != null) &&
        poDeliveryMethodFileFormat != null;

    return {
        invoiceCurrency,
        poDelivery: enablePODelivery
            ? {
                  deliveryEmail: poDeliveryEmail ?? '',
                  deliveryFileFormat: poDeliveryMethodFileFormat,
                  deliveryMethod: poDeliveryMethodType,
              }
            : null,
        vatInformation: null,
    };
}

function vmToBusinessStep(vm: backendServices.ViewModels.CompanyUserProfileViewModel): SupplierSignUpData['business'] {
    return {
        businessName: vm.Company.Name,
        phone: vm.Company.Phone,
        address1: vm.Company.Address1,
        address2: vm.Company.Address2,
        address3: vm.Company.Address3,
        city: vm.Company.City,
        country: vm.Company.Country,
        state: vm.Company.State,
        countryHasStates: !!vm.Company.State,
        postalCode: vm.Company.PostalCode,
        dunsNumber: vm.Company.DUNSNumber ?? undefined,
        fax: vm.Company.Fax ?? '',
    };
}

export function supplierUserProfileVMToSupplierSignUpData(
    vm: backendServices.ViewModels.CompanyUserProfileViewModel
): SupplierSignUpData {
    return {
        customer: vmToCustomerStep(vm),
        business: vmToBusinessStep(vm),
        accountAndContact: vmToAccountAndContactStep(vm),
    };
}
